// extracted by mini-css-extract-plugin
export default {"location-results-list":"H45Uco","location-results-list__overlay":"vjcTip","location-results-list__load-more":"lEfCFt","location-results-list__vpc-banner":"GEJZih"};